exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles-container-2LSklHqk {\n  background-color: var(--brand-dark);\n  position: relative;\n  z-index: 0;\n}\n", ""]);

// exports
exports.locals = {
	"container": "styles-container-2LSklHqk"
};